import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';

import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/rx-claims-list';

 /*********************** */
const _memberPrescriptionClaimsWidget = ( props ) => {
    return (
        <div className='ui-member-prescription-claims-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                onActionClick={ props.onActionClick }
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
            />
        </div>
    );
};

// set display name
_memberPrescriptionClaimsWidget.displayName = 'memberPrescriptionClaimsWidget';

// set default props
_memberPrescriptionClaimsWidget.defaultProps = {};

// prop types
_memberPrescriptionClaimsWidget.propTypes = {};


/************************** */

const memberPrescriptionClaimsWidgetPreloader = ( ) => {
    return (
        <div className='ui-order-details-prescriptions-preloaderr'>
            <TableSearchInlineWidgetPreloader
                className='ui-order-details-prescriptions-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberPrescriptionClaimsWidgetPreloader.displayName = 'memberPrescriptionClaimsWidgetPreloader';

// set default props
memberPrescriptionClaimsWidgetPreloader.defaultProps = {};

// prop types
memberPrescriptionClaimsWidgetPreloader.propTypes = {};

/************************** */

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberPrescriptionClaimsWidget as MemberPrescriptionClaimsWidget } from 'ui/views/widgets/memberPrescriptionClaimsWidget';
 *
 * // render
 * <MemberPrescriptionClaimsWidget propName='propValue'/>
 */
export const memberPrescriptionClaimsWidget = withNetworkState( memberPrescriptionClaimsWidgetPreloader, _memberPrescriptionClaimsWidget );
